import React from 'react';

import PluridIcon from '../../PluridIcon';

import {
    PluridIconProperties,
} from '../../interfaces';



const PluridIconSubscription: React.FC<PluridIconProperties> = (properties) => {
    return (
        <PluridIcon
            {...properties}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
                <polygon points="254.34 433.05 126.92 560.47 -0.5 433.05 254.34 433.05"/>
                <polygon points="745.66 562.63 873.08 435.21 1000.5 562.63 745.66 562.63"/>
                <path d="M167.15,433.05A339.62,339.62,0,0,1,812.78,367.9q6.15,14.55,10.87,29.52h79.88C857.84,217.12,694.5,83.73,500,83.73,292.89,83.73,121.11,235,89.09,433.05Z"/>
                <path d="M833.66,562.63A339.47,339.47,0,0,1,175,598.26H95.4c44.16,182.48,208.55,318,404.6,318,208.61,0,381.38-153.45,411.59-353.64Z"/>
                <path d="M390.72,629.61l27.86-42.33c25.27,20.3,51,33.69,80.12,33.69,35.21,0,52.05-17.17,52.05-46.22,0-71.27-146.64-61.44-146.64-162.62,0-58.53,41.57-97,104.31-97,44.49,0,73.21,18.58,96.86,43.63l-31.85,36.06c-19.87-18.57-36.39-28.94-62.2-28.94-29.48,0-47.08,15.55-47.08,43.2,0,64.79,146.64,51.83,146.64,161.32,0,59.83-41,101.29-112.09,101.29C462.42,671.72,418.8,655.31,390.72,629.61Zm93.51-367.36H527v73.64H484.23Zm0,385.28H527v77.1H484.23Z"/>
            </svg>
        </PluridIcon>
    );
}


export default PluridIconSubscription;
